@if (!showSetup) {
  <div class="welcome-text">
    <div class="main-heading">Bienvenue sur Overlayer 👋</div>
    <div class="subheading"></div>
    <div class="main-heading">
      Votre extension Google Workspace pour exploiter plus intelligemment le
      contenu de vos Drives.
      <div class="description">
        En quelques minutes, nous allons connecter Overlayer à votre Google
        Workspace et activer les fonctionnalités avancées de gestion
        documentaire.
      </div>
    </div>
    <p-button
      label="⚙️ Démarrer la configuration"
      severity="contrast"
      class="setup-button"
      (onClick)="showSetupComponent()"
    ></p-button>
  </div>
}

@if (showSetup) {
  <app-setup-onboarding></app-setup-onboarding>
}
